'use strict'
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ButtonComponent } from '../../../src/components/commonComponents/UIComponent';
import Form from '../commonComponents/Form.v2';

class StepFive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        }

        this.nextAction = this.nextAction.bind(this);
        this.backAction = this.backAction.bind(this);
        this.formData = {
            // "value": { "name": "value", "label": "colum", "type": "text" },
            "name": { "name": "name", "label": "Merged Table Name", "type": "text", "requiredFlag": true},
            "modelname": { "name": "modelname", "label": "Model Name", "type": "text", "requiredFlag": true},
        }

    }

    componentWillMount() {

    }

    backAction() {
        this.props.stepData.handleBackTrack(this);
    }
    nextAction(e) {
        e.preventDefault();
        let form_array = jQuery("#mergeForm").serializeArray();
        let tableName = form_array[0]['value'].trim();
        let modalName = form_array[1]['value'].trim();
        let innerText = e.target.innerText;
        if (tableName == "" || tableName == " " || tableName == null) {
            alert("Table name cannot be empty");
        } else if (modalName == "" || modalName == " " || modalName == null) {
            alert("Modal name cannot be empty");
        } else {
            this.props.stepData.performMerge(tableName, innerText, modalName);
        }
    }

    render() {
        let backButton = { "name": "Back", "event":this.backAction };
        return (
            <>
                <div className="card">
                    <div className="card-header d-flex flex-row justify-content-between">
                        <ButtonComponent buttonData={backButton} />
                    </div>
                    <div className="card-body">
                        <form autoComplete="off" id="mergeForm" style={{ maxWidth: "400px" }}>
                            <Form label_array={this.formData} />
                        </form>
                        <button id="mergeButton" className="btn btn-sm btn-primary align-self-end mg-r-10" onClick={this.nextAction}>Save and Execute</button>
                        <button id="mergeLaterButton" className="btn btn-sm btn-primary align-self-end" onClick={this.nextAction}>Save and Execute Later</button>
                        <button id="loadButton" hidden className="btn btn-sm btn-primary align-self-end mg-10" type="button" disabled>
                            <span className="spinner-border spinner-border-sm mg-r-5" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.admin.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(StepFive);
// export default DataMerge;

